import services from '@/services'

export default async function auth ({ from, to, next }) {
  if (from.name && from.name !== to.name) {
    services.event.emitEvent(services.event.BASIC_ACTIONS.DESTROY, {})
  }
  return next()
}
